/**
 * Parcels Details
 */
// @TODO: remove unused functionality 

// React
import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Dialog,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Select,
  FormControl,
  IconButton,
  MenuItem,
  DialogTitle,
  TextField,
  Collapse, FormHelperText,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiStateMachine,
  mdiKeyOutline,
  mdiAccountOutline,
  mdiWarehouse,
  mdiArrowRight,
  mdiFormatListCheckbox,
  mdiPackage,
  mdiPhoneOutline,
  mdiCalendar,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
  mdiClose,
  mdiCheck,
  mdiPackageVariantClosed,
  mdiCounter,
  mdiChevronLeft,
  mdiBarcode,
  mdiAlertCircle,
  mdiFileTableBoxMultiple,
  mdiFileTree,
  mdiCityVariant,
  mdiChevronUp,
  mdiChevronDown, mdiInformation, mdiFileDocumentOutline,
} from '@mdi/js';

// Components
import ListParcelItems from './list';
import InventoryItemsList from './inventoryItemsList';

// Helper
import {
  translate,
  formaterPhoneNumber,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Props, Product } from './interfaces';
import Pagination from '@material-ui/lab/Pagination';
import Modal from '../../components/Modal';
import { useForm } from 'react-hook-form';
import PaginationNumber from '../../components/PaginationNum';
import { InventoryItem } from '../orderPack/interfaces';
import parcelsRepository from "client-sdk/src/Repository/parcels-repository";
import parcelItemRepository from 'client-sdk/src/Repository/parcel-items-repository';
import inventoryItemsRepository from "client-sdk/src/Repository/inventory-items-repository";
import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotification";
import AuthContext from '../../authContext';
import { getBlockingTickets } from '../../api/ticket/get';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    allocateIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingTop: '10px',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    card: {
      minWidth: '270px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
  }),
);

export function Details(props: Props) {
  const history = useHistory();
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [ticket, setTicket] = useState(null)
  const [openItemsNotFound, setOpenItemsNotFound] = useState(false as boolean);
  const [openBarcode, setOpenBarcode] = useState(false as boolean);
  const [openBarcodeSerial, setOpenBarcodeSerial] = useState(false as boolean);
  const [barcodeModalChanged, setBarcodeModalChanged] = useState(
    false as boolean,
  );
  const [checkBarcodeDialogClosed, setCheckBarcodeDialogClosed] = useState(
    false as boolean,
  );
  const [
    openDialogForChangeParcelStatus,
    setOpenDialogForChangeParcelStatus,
  ] = useState(false as boolean);
  const [
    openDialogForItemsNotRegistered,
    setOpenDialogForItemsNotRegistered,
  ] = useState(false as boolean);
  const [openRegisterItems, setOpenRegisterItems] = useState(false as boolean);
  const [openLocatingItems, setOpenLocatingItems] = useState(false as boolean);
  const [openItemHasAlreadyLocated, setOpenItemHasAlreadyLocated] = useState(false as boolean);
  const { handleSubmit, register, watch, errors } = useForm();
  const [id, setId] = useState(-1 as number);
  const [serial, setSerial] = useState('');
  const [loading, setLoading] = useState(false)
  const [groupChange, setGroupChange] = useState(false)
  const [description, setDescription] = useState('');
  const [inventoryItems, setInventoryItems] = useState([] as any[]);
  const [barcode, setBarcode] = useState('');
  const [product, setProduct] = useState({} as Product);
  const [unit, setUnit] = useState('');
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 100,
  } as any);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [parcel, setParcel] = useState({});
  const [inventoryItem, setInventoryItem] = useState([]);
  const [
    inventoryItemsWithSerialLoading,
    setInventoryItemsWithSerialLoading
  ] = useState(false);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState(
    []
  );
  const [inventoryItemsWithStatus, setInventoryItemsWithStatus] = useState(
    []
  );
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);
  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleCloseDialogForItemsNotRegistered = () => {
    setOpenDialogForItemsNotRegistered(false);
  };

  const setOpenBarcodeFunc = (product: Product) => {
    setId(product.id);
    setOpenBarcode(true);
  };

  const handleCloseDialogForChangeParcelStatus = () => {
    setOpenDialogForChangeParcelStatus(false);
  };
  const updateParcelsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await parcelsRepository.updateParcelStatus({
        payload
      });
      handleNotfication("محموله با موفقیت به روز رسانی شد", "success");
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const handleSetParcelStatus = async (status: string) => {
    if (status === 'LOCATED') setDescription('');
    await updateParcelsStatus({
      id: props.match.params.id,
      body: { status: status.replace(/'/g, '"'), description: description },
      pagination: {
        ...filtersValues,
      },
      callback: () => {
        history.goBack()
      },
    });
    setOpenDialogForItemsNotRegistered(false);
    setOpenDialogForChangeParcelStatus(false);
  };

  const checkBarcode = async () => {
    setCheckBarcodeDialogClosed(true);
    setBarcodeModalChanged(!barcodeModalChanged);
  };
  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithSerialLoading(true);
      const {
        response,
        callback
      } = await inventoryItemsRepository.getInventoryItemsWithSerial(
        { payload },
        payload.callback
      );
      setInventoryItemsWithSerial(response.data.content);
      if (callback) {
        callback();
      }
      if (response.data.content.length === 0)
        handleNotfication("هیچ آیتمی پیدا نشد.", "warn");
    } catch (error) {
      handleError(error.response);
    } finally {
      setInventoryItemsWithSerialLoading(false);
    }
  };
  const getParcelInventoryItems = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const {
        response,
        callback
      } = await inventoryItemsRepository.getParcelInventoryItems({ payload });
      setInventoryItem(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
      if (callback) {
        callback();
      }
    } catch (error) {
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }
  };

  const updateInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.locateInventoryItemsUnit({
        payload
      });
      handleNotfication(
        "وضعیت آیتم مورد نظر با موفقیت تغییر کرد ",
        "success"
      );
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const checkSerialFunc = ({ serial }: { serial: string }) => {
    if(groupChange) {
      locateInventoryItems(serial)
    }else {
      updateInventoryItemsStatus({
        id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
        body: { barcode: parseInt(serial) },
        ...filtersValues,
        callback: () => {
          getParcelInventoryItems({
            ...filtersValues,
            "status.equals": undefined,
            parcelId: { equals: props.match.params.id }
          });
          setOpenBarcode(false);
        }
      });
    }
    setSerial('');
    setOpenRegisterItems(false);
  };
  const handleAllocateUserFunc = () => {
    updateInventoryItemsStatus({
      id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
      body: { barcode: parseInt(unit) },
      ...filtersValues,
      callback: () => {
        //
      }
    });
    setOpenLocatingItems(false);
    setOpenRegisterItems(false);
  };

  const handleAllocateAllItemsUserFunc = () => {
    handleAllocateAllItemsUser();
  };
  const updateAllInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.locateAllInventoryItemsUnit(
        { payload }
      );
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  }
  const handleAllocateAllItemsUser = () => {
    const inventoryItemsIds = inventoryItems.map(
      (inventoryItem: any) => inventoryItem.id,
    );
    updateAllInventoryItemsStatus({
      body: {
        barcode: unit,
        ids: inventoryItemsIds
      },
      ...filtersValues,
      callback: () => {
        getParcelInventoryItems({
          ...filtersValues,
          parcelId: { equals: props.match.params.id }
        });
        setOpenLocatingItems(false);
        setOpenRegisterItems(false);
        setInventoryItems([]);
      },
    });
  };

  const selectAll = () => {
    setGroupChange(true)
    setOpenBarcode(true)
  }

  const locateInventoryItems = async (barcode: string) => {
    try {
      setLoading(true)
      await parcelItemRepository.locateAllParcelItemsUnit({payload: {id: parcel.id, body: {barcode}}})
      handleNotfication("وضعیت آیتم ها بروزرسانی شد.", "success")
      getParcelInventoryItems({
        ...filtersValues,
        "status.equals": undefined,
        parcelId: { equals: props.match.params.id }
      });
      setOpenBarcode(false);
      setLoading(false)
    } catch (error) {
      handleError(error?.response)
    }
  }

  const getNotLocatedParcelItems = () => {
    if (parcel.items) {
      return parcel.items.filter((item: any) => item.status !== 'LOCATED');
    }
    return [];
  };

  const getInventoryItemsWithStatus = () => {
    const findNotLocated = inventoryItem.filter((el: InventoryItem) => (el.status !== 'LOCATED' && el.status !== 'CHECKED' && el.status !== 'PICKED'));
    if (findNotLocated?.length) {
      setOpenDialogForItemsNotRegistered(true);
      return;
    }
    setOpenDialogForChangeParcelStatus(true);
  };

  const handleCloseItemHasAlreadyLocated = () => {
    setOpenItemHasAlreadyLocated(false);
    setBarcode('');
  };
  const cleanInventoryItems = () => {
    setInventoryItemsCount(0);
    setInventoryItems([]);
  }
  useEffect(() => {
    return () => {
      cleanInventoryItems();
    };
  }, []);

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number,
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };
  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error) {
      handleError(error.response);
    }
  };

  useEffect(() => {
    const { id } = props.match.params;
    getParcelWithId(id);
    getParcelInventoryItems({
      ...filtersValues,
      parcelId: { equals: id }
    });
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (checkBarcodeDialogClosed) handleCloseBarcodeSerial(true);
  }, [barcodeModalChanged]);

  useEffect(() => {
    if (inventoryItemsWithSerial.length !== 0) {
      setBarcode('');
      const oldInventoryItem = inventoryItems.filter(
        item =>
          inventoryItemsWithSerial[0].serialNumber === item.serialNumber,
      );
      if (
        oldInventoryItem.length === 0 &&
        inventoryItemsWithSerial[0]?.status !== 'LOCATED'
      )
        setInventoryItems([
          ...inventoryItems,
          inventoryItemsWithSerial[0],
        ]);
      if (inventoryItemsWithSerial[0]?.status === 'LOCATED') {
        setOpenItemHasAlreadyLocated(true);
      }
    }
  }, [inventoryItemsWithSerial]);

  useEffect(() => {
    getTicket()
  }, [])
  const getTicket = async () => {
    const { id } = props.match.params;
    try {
      const res = await getBlockingTickets({'serviceId': 1, linkType: 'parcel', linkId: id, 'status.notIn': 'CLOSED'})
      setTicket(res.data[0])
      res.data.length > 0 && handleNotfication('محموله دارای تیکت است.', 'warn')
    } catch (error) {
      handleError(error)
    }
  }


  const handleClose = () => {
    setOpenRegisterItems(false);
    setOpenLocatingItems(false);
  };

  const handleCloseItemsNotFound = () => {
    setOpenItemsNotFound(false);
  };

  const removeItem = (itemDeleted: any) => {
    const newValue = inventoryItems.filter(
      (item: any) => item.id !== itemDeleted.id
    );
    setInventoryItems(newValue);
  }

  const handleCloseBarcode = (setRegistered: boolean) => {
    setOpenBarcode(false);
    if (setRegistered && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setOpenRegisterItems(true);
    } else if (setRegistered && inventoryItemsWithSerial.length === 0) {
      setOpenItemsNotFound(true);
    }
  };

  const handleCloseBarcodeSerial = (setRegistered: boolean) => {
    setOpenBarcodeSerial(false);
    if (setRegistered && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setOpenLocatingItems(true);
    } else if (setRegistered && inventoryItemsWithSerial.length === 0) {
      setOpenItemsNotFound(true);
    }
  };

  const handleChangePageNum = (pageNumber: number) => {
    setFiltersValues({ ...filtersValues, page: pageNumber });
  };

  const handleFilterStatus = (status: string) => {
    if (filtersValues?.['status.equals'] === status) {
      setFiltersValues((prevState: any) => ({
        ...prevState, 'status.equals': undefined,
      }));
      return;
    }
    setFiltersValues((prevState: any) => ({
      ...prevState, 'status.equals': status,
    }));
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات محموله 
        ${parcel.destinationName}

     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{parcel.id}</span>
      </div>

      <Grid
        container
        direction="row"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>

        <Link
          to={`/parcels/receipts/${parcel.id}`}
          target="_blank"
          style={{ textDecoration: 'none', marginRight: 'auto' }}
        >
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Icon path={mdiPrinter} size={1} />}
          >
            {'چاپ حواله'}
          </Button>
        </Link>
        {ticket && <Button
          variant="contained"
          color="primary"
          size="large"
          style={{ marginRight: '20px' }}
          onClick={() => {
            history.push(
              `/ticketing/${ticket?.id}`
            );
          }}
        >
          سابقه تیکت
        </Button>}
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCityVariant} size={1} className={classes.icon} />
                {'نام شرکت:  '}
              </span>
              <span>{parcel.partnerName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {'تعداد آیتم های محموله:  '}
              </span>

              <span>{inventoryItemsCount}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPackage} size={1} className={classes.icon} />
                {'تعداد کارتن:  '}
              </span>

              <span>{parcel.boxCount}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {'تاریخ تحویل به انبار:  '}
              </span>
              <span>
                <span>
                  {parcel.shippingDate &&
                    `${jMoment(parcel.deliveryDate, 'YYYY/MM/DD')
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>

          <Divider className={classes.divider} />
          <div className={classes.collapseIcon}>
            <IconButton onClick={handleCollapse}>
              <Icon
                path={open ? mdiChevronUp : mdiChevronDown}
                color='white'
                size={1}
              />
            </IconButton>
          </div>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <Grid style={{ margin: 0 }} xs={12} container spacing={3}>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'نام مسئول حمل:  '}
                  </span>

                  <span>{parcel.agentName}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPhoneOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'شماره همراه مسئول حمل:  '}
                  </span>
                  <span>
                    {formaterPhoneNumber(parcel.agentPhoneNumber)}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                    {'تاریخ ثبت محموله:  '}
                  </span>
                  <span>
                    <span>
                      {parcel.deliveryDate &&
                        `${jMoment(parcel.shippingDate, 'YYYY/MM/DD')
                          .locale('fa')
                          .format('jYYYY/jMM/jDD')}`}
                    </span>
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiFormatListCheckbox}
                      size={1}
                      className={classes.icon}
                    />
                    {'نوع ارسال:  '}
                  </span>
                  <span>
                    {translate(parcel.deliveryType)}
                  </span>
                </div>
              </Grid>

              <Divider className={classes.divider} />

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'شناسه محموله:  '}
                  </span>

                  <span>{parcel.id}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiWarehouse}
                      size={1}
                      className={classes.icon}
                    />
                    {'انبار مقصد:  '}
                  </span>

                  <span>{parcel.destinationName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarClock}
                      size={1}
                      className={classes.icon}
                    />
                    {'بازه تحویل محموله:  '}
                  </span>
                  <span>
                    <span>
                      {parcel.deliveryStartTime &&
                        jMoment(parcel.deliveryStartTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                      {' - '}
                      {parcel.deliveryEndTime &&
                        jMoment(parcel.deliveryEndTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                    </span>
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiStateMachine}
                      size={1}
                      className={classes.icon}
                    />
                    {'وضعیت تحویل :  '}
                  </span>
                  <span>{translate(parcel.status, 'parcel')}</span>
                </div>
              </Grid>
              <Divider className={classes.divider} />
              <Grid item xs={12} sm={6}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiMapMarkerOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'آدرس انبار مقصد :  '}
                  </span>
                  <span>{parcel.destinationAddress}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiFileDocumentOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'توضیحات :  '}
                  </span>
                  <span>{parcel.description}</span>
                </div>
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      </Paper>
      <Grid style={{ marginTop: '30px', marginBottom: '20px' }} container alignItems='center' justify="space-between">
        <div className={classes.card}>
          <div className={classes.cardItem}>
            {filtersValues?.status}
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={filtersValues?.['status.equals'] === 'REGISTERED' ? 'contained' : undefined}
              onClick={() => {
                handleFilterStatus('REGISTERED');
              }}
            >
              جایگذاری نشده
            </Button>
          </div>
          <div className={classes.cardItem}>
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={filtersValues?.['status.equals'] === 'LOCATED' ? 'contained' : undefined}
              onClick={() => {
                handleFilterStatus('LOCATED');
              }}
            >
              جایگذاری شده
            </Button>
          </div>
        </div>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          style={{ marginBottom: '20px' }}
          startIcon={<Icon path={mdiBarcode} size={1} />}
          onClick={() => {
            setOpenBarcodeSerial(true);
          }}
        >
          {'چک کردن بارکد'}
        </Button>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {inventoryItemsLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            inventoryItem && (
              <ListParcelItems
                operatorId={parcel.operatorId}
                setOpenBarcode={setOpenBarcodeFunc}
                data={inventoryItem}
                selectAll={selectAll}
                checkedAll={getNotLocatedParcelItems().length == 0}
              />
            )
          )}
        </Grid>
        <Grid id="showFilter" item xs={12} sm={6}>
          {inventoryItem && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleCloseSelect}
                className={classes.showCount}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {inventoryItem && (
            <>
              <Pagination
                count={Math.ceil(inventoryItemsCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <PaginationNumber onChange={handleChangePageNum} />
            </>
          )}
        </Grid>
      </Grid>
      <Grid xs={12} style={{ marginTop: '30px' }} container justify="flex-end">
        <Button
          aria-label="register-parcel"
          onClick={getInventoryItemsWithStatus}
          disabled={!!ticket}
          variant="contained"
          color="secondary"
          size="large"
        >
          <span className="">{'تایید جایگذاری محموله'}</span>
          <Icon path={mdiChevronLeft} size={1} />
        </Button>
      </Grid>
      <Dialog
        fullWidth
        open={openRegisterItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.green.main} />
          </div>
          <div style={{ width: '80%', marginBottom: '30px' }}>
            <Grid>
              <TextField
                fullWidth
                autoFocus
                id="unit"
                name="unit"
                label="واحد"
                value={unit}
                onChange={e => setUnit(e.target.value)}
                inputRef={register({ required: true })}
                error={errors.unit && true}
              />
            </Grid>
          </div>
          <div>
            <div>
              {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
             "${product.status === 'REGISTERED' ? 'جایگذاری شده' : 'تطبیق شده'}"
          مطمئن هستید؟`}
            </div>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={handleAllocateUserFunc}
                fullWidth
                variant="contained"
                disabled={!unit}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForChangeParcelStatus}
        onClose={handleCloseDialogForChangeParcelStatus}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForChangeParcelStatus ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForChangeParcelStatus}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {` از 
            تغییر وضعیت محموله به جایگذاری شده
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForChangeParcelStatus}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={e => handleSetParcelStatus('LOCATED')}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openItemHasAlreadyLocated}
        onClose={handleCloseItemHasAlreadyLocated}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseItemHasAlreadyLocated ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemHasAlreadyLocated}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiInformation} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {`آیتم با سریال
            "${inventoryItemsWithSerial[0]?.serialNumber}"
              قبلا جایگذاری شده است`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1} justify="flex-end">
            <Grid item xs={4}>
              <Button
                onClick={handleCloseItemHasAlreadyLocated}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بستن'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openDialogForItemsNotRegistered}
        onClose={handleCloseDialogForItemsNotRegistered}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForItemsNotRegistered ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForItemsNotRegistered}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {inventoryItemsWithStatus.length > 1 ? (
              <div>
                {`تعداد 
                "${inventoryItemsWithStatus.length}"
                آیتم از کالاها
                مانند آیتم با مشخصات 
              "${'نام کالا'} : ${inventoryItemsWithStatus[0]?.productName
                  }  - ${'شناسه کالا'} : ${inventoryItemsWithStatus[0]?.productId
                  }"
              هنوز جایگذاری داده نشده است.`}
              </div>
            ) : (
              <div>
                آیتم با شناسه
                {inventoryItem?.filter((el: InventoryItem) => (el.status !== 'LOCATED' && el.status !== 'CHECKED' && el.status !== 'PICKED'))?.map((el: any, i: number) =>
                  <span>{i !== 0 && '-'} {el.id} </span>)}
                هنوز جایگذاری داده نشده است
              </div>
            )}
            <div>
              <Grid>
                <TextField
                  fullWidth
                  id="description"
                  name="description"
                  autoFocus
                  rows={3}
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  label="توضیحات"
                />
              </Grid>
            </div>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForItemsNotRegistered}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'بررسی مجدد'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={e => handleSetParcelStatus('CONFLICTED')}
                fullWidth
                variant="contained"
                size="large"
              >
                {'ایجاد مغایرت'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openLocatingItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.green.main} />
          </div>
          <div style={{ width: '80%', marginBottom: '30px' }}>
            <Grid>
              <TextField
                fullWidth
                autoFocus
                id="unitItems"
                name="unitItems"
                label="واحد"
                value={unit}
                onChange={e => setUnit(e.target.value)}
                inputRef={register({ required: true })}
                error={errors.unit && true}
              />
            </Grid>
          </div>
          <div>
            {id !== -1 || inventoryItemsWithSerial.length === 0 ? (
              <div>
                {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
            جایگذاری شده
          مطمئن هستید؟`}
              </div>
            ) : (
              <div>
                <Grid
                  style={{ marginBottom: '15px' }}
                  container
                  alignItems="center"
                >
                  {`تعداد
            "${inventoryItems.length}"
           آیتم انتخاب شده است`}
                </Grid>
                <div className={classes.cancelTitle}>
                  {` از
            تغییر وضعیت کالاها
            به
            "${inventoryItemsWithSerial[0]?.status === 'REGISTERED'
                      ? 'جایگذاری شده'
                      : 'تطبیق شده'
                    }"
          مطمئن هستید؟`}
                </div>
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={handleAllocateAllItemsUserFunc}
                fullWidth
                variant="contained"
                size="large"
                disabled={!unit}
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openItemsNotFound}
        onClose={handleCloseItemsNotFound}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseItemsNotFound ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemsNotFound}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiAlertCircle} size={4} color="#faa320" />
          </div>
          <div className={classes.cancelTitle}>
            {`آیتم مورد نظر با بارکد 
            " ${barcode} "
            یافت نشد.`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container justify="flex-end">
            <Button
              autoFocus
              onClick={handleCloseItemsNotFound}
              variant="contained"
              color="secondary"
              size="large"
            >
              {'باشه'}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="lg"
        onClose={() => handleCloseBarcode(false)}
        open={openBarcode}
        title={
          <Grid container justify="center">
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </Grid>
        }
        content={
          <form onSubmit={handleSubmit(checkSerialFunc)}>
            <Grid container>
              <Grid item xs={12}>
                <p>{'سریال یونیت مورد نظر را اسکن کنید'}</p>
              </Grid>
              <Grid xs={12}>
                <div style={{ width: '100%', marginBottom: '30px' }}>
                  <TextField
                    fullWidth
                    autoFocus
                    id="serial"
                    name="serial"
                    label="سریال"
                    inputRef={register({ required: true })}
                  />
                </div>
                <FormHelperText error focused>
                  {errors.serial && 'سریال یونیت الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Grid xs={12} container justify="flex-end">
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  type="submit"
                  disabled={watch('serial')?.length === 0 || loading}
                  startIcon={<Icon path={mdiFileTableBoxMultiple} size={1} />}
                >
                  {'جایگذاری کالا'}
                  {loading && <CircularProgress size={20}/>}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
      <Modal
        maxWidth="lg"
        onClose={() => handleCloseBarcodeSerial(false)}
        open={openBarcodeSerial}
        title={
          <Grid container justify="center">
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </Grid>
        }
        content={
          <Grid container>
            <BarcodeForm
              id={props.match.params.id}
              inventoryItemsWithSerial={inventoryItemsWithSerial}
              getInventoryItemsWithSerialActionDispatch={
                getInventoryItemsWithSerial
              }
              inventoryItemsWithSerialLoading={
                inventoryItemsWithSerialLoading
              }
            />
            {inventoryItems.length !== 0 ? (
              <>
                <Grid
                  container
                  style={{
                    marginTop: '30px',
                    marginBottom: '30px',
                    maxHeight: '200px',
                    overflowY: 'scroll',
                  }}
                >
                  <InventoryItemsList
                    operatorId={parcel.operatorId}
                    removeItem={(item: any) => removeItem(item)}
                    data={inventoryItems}
                  />
                </Grid>
                <Grid
                  xs={12}
                  container
                  spacing={3}
                  justify="flex-end"
                  alignItems="center"
                >
                  <div style={{ margin: '0 20px' }}>
                    <span>{'تعداد : '}</span>
                    <span>{inventoryItems.length}</span>
                  </div>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    startIcon={<Icon path={mdiFileTree} size={1} />}
                    onClick={checkBarcode}
                  >
                    {'جایگذاری کالا ها'}
                  </Button>
                </Grid>
              </>
            ) : null}
          </Grid>
        }
      />
    </div>
  );
}

export type Inputs = {
  barcodeSerial: string;
};

function BarcodeForm(props: any) {
  const { handleSubmit, register, getValues, setValue, watch, errors,  } = useForm<Inputs>();
  const barcodeRef = useRef()

  useEffect(() => {
    if (props.inventoryItemsWithSerial.length !== 0) {
      setValue('barcodeSerial', '');
    }
  }, [props.inventoryItemsWithSerial])

  const checkBarcodeFunc = (data: any) => {
    props.getInventoryItemsWithSerialActionDispatch({
      serialNumber: { equals: data.barcodeSerial },
      parcelId: { equals: props.id }
    });
    barcodeRef.current.focus()
  };

  return (
    <form
      style={{ width: '100%' }}
      onSubmit={handleSubmit(checkBarcodeFunc)}
    >
      <Grid container>
        <Grid xs={12}>
          <div style={{ width: '100%', marginBottom: '30px' }}>
            <TextField
              fullWidth
              autoFocus
              id="barcodeSerial"
              name="barcodeSerial"
              label="بارکد"
              InputProps={{
                readOnly: props.inventoryItemsWithSerialLoading
              }}
              inputRef={e => {
                barcodeRef.current = e
                register(e,{ required: true })
              }}
            />
          </div>
        </Grid>
        <Grid xs={12} container justify="flex-end">
          <Button
            variant="contained"
            color="secondary"
            size="large"
            disabled={
              watch('barcodeSerial')?.length === 0 ||
              props.inventoryItemsWithSerialLoading
            }
            startIcon={<Icon path={mdiFileTableBoxMultiple} size={1} />}
            type="submit"
          >
            {'یافتن کالا'}
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}


// @ts-ignore
export default Details;
